<script setup>
import SkillsSlider from "@/components/SkillsSlider.vue";
import TimelineBlock from "@/components/TimelineBlock.vue";

const experience = [
  {
    date: "Feb 2024 - Present",
    title: "Server, Host & Expo",
    subtitle: "Firehall Pizza Co.",
    text: "Greeted customers, managed seating rotations and table sections, took orders, ran food, billed tables, and delivered excellent customer service throughout each shift.",
  },
  {
    date: "Mar 2024 - Aug 2024",
    title: "Labourer",
    subtitle: "Georgian Shores Construction Ltd.",
    text: "Efficiently allocated daily tasks, managed time to meet deadlines, coordinated with coworkers, and solved on-site challenges to keep projects on schedule.",
  },
  {
    date: "Sept 2023 - Mar 2024",
    title: "Labourer & Office Admin.",
    subtitle: "Hawthorn Construction",
    text: "Organized and managed schedules to ensure timely task completion, delegated duties effectively, solved on-site issues, and maintained steady workflow through strong communication and time management.",
  },
  {
    date: "Jan 2022 - Aug 2023",
    title: "Customer Service/Deliveries Associate",
    subtitle: "The Home Depot",
    text: "Communicated with employees and customers to ensure timely, accurate orders and high satisfaction, completed training to boost product knowledge, and consistently delivered excellent service.",
  },
];

const education = [
  {
    date: "Sept 2024 - Present",
    title: "Business Diploma",
    subtitle: "Georgian College",
    text: "",
  },
  {
    date: "Summer 2023",
    title: "Entry-Level Contruction PM Certificate",
    subtitle: "George Brown College",
    text: "",
  },
];
</script>

<template>
  <section id="resume-section">
    <h2 class="section-title">Resume</h2>
    <p class="section-text mt-4 mb-0">
      <em class="text-primary fw-bold">Business student at Georgian College</em> proficient in customer service.
      Excellent time management and organizational skills with the ability to adapt quickly to solve problems and face
      challenges, confident communication skills and the ability to work in a team to provide accurate and innovative
      solutions for customers.
    </p>

    <div class="row align-items-start mt-4 gx-5">
      <div class="col-xl-6">
        <h3 class="h5 mb-0">Skills</h3>
        <div class="bg-light p-4 rounded-3 mt-3">
          <SkillsSlider title="Microsoft Office" :percentage="70" />
          <SkillsSlider title="Customer Service" :percentage="90" class="mt-3" />
          <SkillsSlider title="Leadership & Teamwork" :percentage="75" class="mt-3" />
          <SkillsSlider title="Project Management" :percentage="70" class="mt-3" />
          <SkillsSlider title="Strategic Problem Solving" :percentage="85" class="mt-3" />
          <SkillsSlider title="Communication & Mentoring" :percentage="90" class="mt-3" />
          <SkillsSlider title="Adaptability & Resilience" :percentage="85" class="mt-3" />
        </div>

        <h3 class="h5 mb-0 mt-4">Education</h3>
        <TimelineBlock :timelineItems="education" class="mt-3" />
      </div>
      <div class="col-xl-6 mt-4 mt-xl-0">
        <h3 class="h5 mb-0">Experience</h3>
        <TimelineBlock :timelineItems="experience" class="mt-3" />
      </div>
    </div>
  </section>
</template>

<style lang="sass" scoped></style>
